import * as React from 'react';
import * as styles from './Fact.css';
import { TFactType } from '../../types/developerV2/fact';
import {
  PictogramB2BSpeciality40,
  PictogramBuildingCommissioning40,
  PictogramBuildingBuilding40,
  PictogramProductTrust40,
} from '@cian/ui-kit-design-tokens/pictograms';
import { Tooltip } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16, ISVGIconProps } from '@cian/ui-kit-design-tokens/icons';

interface IFactProps {
  promoColor: string | null;
  title: string;
  text: string;
  description?: string;
  type: TFactType;
}

export const Fact = ({ title, type, text, description, promoColor }: IFactProps) => {
  const Icon = React.useMemo((): React.FC<ISVGIconProps> => {
    switch (type) {
      case 'foundationYear':
        return PictogramBuildingBuilding40;
      case 'inProgress':
        return PictogramB2BSpeciality40;
      case 'onTime':
        return PictogramProductTrust40;
      case 'completed':
      default:
        return PictogramBuildingCommissioning40;
    }
  }, [type]);

  return (
    <li className={styles['fact']}>
      <div style={promoColor ? { color: promoColor } : undefined}>
        {<Icon color={promoColor ? 'current_color' : undefined} />}
      </div>
      <div className={styles['description']}>
        <span className={styles['title']}>{title}</span>
        <span className={styles['text']}>
          {text}
          {description && (
            <span className={styles['info']}>
              <Tooltip theme="white" title={<span className={styles['tooltip-text']}>{description}</span>}>
                <div className={styles['inner-info']}>
                  <IconFunctionalInformationCircle16 />
                </div>
              </Tooltip>
            </span>
          )}
        </span>
      </div>
    </li>
  );
};
